import {Map, View} from "ol";
import {defaults, FullScreen} from "ol/control";
import {fillMapTypeSelectWithTypes, getSavedMapLayer} from "./changeType";
import {fromLonLat} from "ol/proj";
import {EpBoundariesLayer} from "./layers/boundaries";
import {Select, Snap} from "ol/interaction";
import {selectStyle} from "./styles/select";
import MapBrowserEventType from "ol/MapBrowserEventType";
import {EpSectorsLayer} from "./layers/sectors";
import {EpDevicesLayer} from "./layers/devices";
import {EpLayer} from "./layers/layer";
import {EpZonesLayer} from "./layers/zones";
import {sectorsStyle} from "./styles/sectors";
import * as $ from "jquery";
import {LayerControl} from "./controls/LayerControl";
import {EpBdlLayer} from "./layers/bdl";
import {EpPointerLayer} from "./layers/pointer";
import {EpInventoryZonesLayer} from "./layers/inventory_zones";
import {ContextMenuFeature} from "./menu/ContextMenuFeature";
import {DefaultContextMenu} from "./menu/DefaultContextMenu";
import {RulerControl} from "./controls/RulerControl";
import {Ruler} from "./extras/Ruler";
import {HelpTooltip} from "./extras/HelpTooltip";
import {HunterPointsLayer} from "./layers/hunter-points";

export class EpMap {
    ruler = null;
    helpTooltip = null;
    mapLayer = null;

    constructor(options = {}) {

        let that = this;
        this.layers = [];

        this.options = {
            ...{
                center: fromLonLat([21, 52.23]),
                target: 'mapContainer',
                withBoundariesLayer: false,
                updateSizeAfterInit: true,
                fitSectorsAndBoundariesAfterInit: true,
                updateSizeDelay: 100,
                height: null,
                ruler: false,
                helpTooltip: true
            }, ...options
        };

        fillMapTypeSelectWithTypes();
        this.boundaries = new EpBoundariesLayer();
        this.container = $('#' + this.options.target);

        this.map = new Map({
            target: this.options.target,
            layers: [
                this.getMapLayer(),
            ],
            view: this.getView(),
            controls: defaults({attribution: false}).extend([new FullScreen()])
        })
        this.map.epMap = this;

        this.contextMenu = new DefaultContextMenu();
        this.contextMenuFeature = new ContextMenuFeature(this);

        if (this.options.withBoundariesLayer) {
            this.addBoundariesLayer();
        }

        if (this.options.height) {
            this.changeSize(this.options.height);
        }

        if (this.options.updateSizeAfterInit) {
            setTimeout(function () {
                that.updateSize()

                if (that.options.fitSectorsAndBoundariesAfterInit) {
                    that.fitSectorsAndBoundaries();
                }
            }, this.options.updateSizeDelay);
        }

        this.addBdlLayer();
        this.tooltipVisible = false;

        this.layerControl = new LayerControl({epMap: this});
        this.map.addControl(this.layerControl);

        if(this.options.helpTooltip) {
            this.helpTooltip = new HelpTooltip(this);
        }

        if(this.options.ruler) {
            this.addRuler();
        }

        return this;
    }

    changeSize(height) {
        this.container.height(height - 32);
    }

    /**
     * Get EP layer by name
     * @param name
     * @returns EpLayer
     */
    getEpLayerByName(name) {
        if (['sectors', 'boundaries', 'devices'].includes(name)) {
            return this[name];
        }

        return this['_' + name];
    }

    getMapLayer() {
        if(this.mapLayer == null) {
            this.mapLayer = getSavedMapLayer();
        }

        // let mapTypeSelect = this.container.parent().closest('div').find("[name='mapType']");
        // let alterMapSelect = $('#mapType');
        //
        // if (mapTypeSelect.length === 0) {
        //     if(alterMapSelect.length === 0) {
        //         mapTypeSelect = null;
        //     }else{
        //         mapTypeSelect = alterMapSelect;
        //     }
        // }

        // if (mapTypeSelect) {
        //     mapTypeSelect.change(function () {
        //         changeMapType(layer, $(this).val());
        //     })
        // }

        return this.mapLayer;
    }

    getOlMap() {
        return this.map;
    }

    getView() {
        if (!this.view) {
            this.view = new View({
                center: this.options.center,
                zoom: 10
            });
        }

        return this.view;
    }

    addSnap(source = null) {
        this.snap = new Snap({source});
        return this.snap;
    }

    addSelect(layers = [], options = {}) {
        options = {
            ...{
                multi: false
            }, ...options
        };

        this.canSelect = true;
        let that = this;

        this.select = new Select({
            layers,
            style: selectStyle,
            condition: function (e) {
                return e.type === MapBrowserEventType.SINGLECLICK && that.canSelect;
            },
            ...options
        });

        return this.select;
    }

    addCustomLayer(layer) {
        this.map.addLayer(layer.getLayer());

        this['_' + layer.name] = layer;
        this.layers = [...this.layers, layer];

        return layer;
    }

    addLayer(name, style = undefined, title = null) {
        let layer = new EpLayer(this);
        layer.setStyle(style);
        layer.name = name;
        layer.title = title ?? name;

        this.map.addLayer(layer.getLayer());

        this['_' + name] = layer;
        this.layers = [...this.layers, layer];

        return layer;
    }

    addBoundariesLayer() {
        this.boundaries = new EpBoundariesLayer(this);
        this.map.addLayer(this.boundaries.getLayer());

        this.layers = [...this.layers, this.boundaries];

        return this.boundaries;
    }

    addSectorsLayer() {
        this.sectors = new EpSectorsLayer(this);
        this.map.addLayer(this.sectors.getLayer());

        this.layers = [...this.layers, this.sectors];

        return this.sectors;
    }

    addInventoryZonesLayer() {
        this.inventory_zones = new EpInventoryZonesLayer(this);
        this.map.addLayer(this.inventory_zones.getLayer());
        this.inventory_zones.name = 'inventory_zones';

        this.layers = [...this.layers, this.inventory_zones];

        return this.inventory_zones;
    }

    addDevicesLayer() {
        this.devices = new EpDevicesLayer(this);
        this.map.addLayer(this.devices.getLayer());
        this.devices.name = 'devices';

        this.layers = [...this.layers, this.devices];

       // this.layers = [...this.layers, this.devices];

        return this.devices;
    }

    addHunterPointsLayer() {
        this.hunterPoints = new HunterPointsLayer(this);
        this.map.addLayer(this.hunterPoints.getLayer());
        this.hunterPoints.name = 'hunters';

        this.layers = [...this.layers, this.hunterPoints];

       // this.layers = [...this.layers, this.hunterPoints];

        return this.hunterPoints;
    }

    addZonesLayer() {
        this.zones = new EpZonesLayer(this);
        this.map.addLayer(this.zones.getLayer());
        this.zones.name = 'zones';

        this.layers = [...this.layers, this.zones];

        this.layers = [...this.layers, this.zones];

        return this.zones;
    }

    addPointerLayer(){
        this.pointer = new EpPointerLayer(this);
        this.map.addLayer(this.pointer.getLayer());

        return this.pointer;
    }

    async addBdlLayer() {
        this.bdl = new EpBdlLayer(this);
        this.map.addLayer(this.bdl.getLayer());

        this.layers = [...this.layers, this.bdl]

        return this.bdl;
    }

    hideLabelsIfNecessary(epLayers = null) {
        let that = this;

        this.getView().on('change:resolution', function () {
            if (epLayers == null) {
                epLayers = [that.sectors, that.devices, that.zones, that.inventory_zones];
            } else if (typeof epLayers[Symbol.iterator] !== 'function') {
                epLayers = [epLayers];
            }

            for (let epLayer of epLayers) {
                if(typeof epLayer == 'undefined') {
                    continue;
                }

                let features = epLayer.getSource().getFeatures();
                let zoom = that.getView().getZoom();
                let style = epLayer.style;
                let styleWithoutLabels = epLayer.farStyle;

                for (let feature of features) {
                    if (selectStyle != feature.style_) {
                        let data = feature.get('sector-data');
                        if(data) {
                            if ((data.book_records && data.book_records.length > 0 ) || ((data.shutdowns && data.shutdowns.length > 0) || data.district_shutdown_from)) {
                                feature.setStyle(sectorsStyle(feature, false));
                                continue;
                            }
                        }
                        feature.setStyle(zoom < (feature.get('zoomLimit') ?? 12) ? styleWithoutLabels : style);
                    }
                }
            }
        });
    }

    changeStyleUnderZoom(epLayers, zoomLimit = 14) {
        if (typeof epLayers[Symbol.iterator] !== 'function') {
            epLayers = [epLayers];
        }

        let that = this;

        for(let epLayer of epLayers) {
            this.getView().on('change:resolution', function () {
                let zoom = that.getView().getZoom();
                let style = epLayer.style;
                //let styleWithoutLabels = epLayer.farStyle;

                if (zoom < zoomLimit) {
                    //epLayer.getLayer().setStyle(styleWithoutLabels);
                } else {
                    epLayer.getLayer().setStyle(style);
                }
            })
        }
    }

    updateSize() {
        this.map.updateSize();
    }

    fitSectorsAndBoundaries() {
        try {
            if (this.sectors && this.sectors.getSource().getFeatures().length > 0) {
                this.getView().fit(this.sectors.getSource().getExtent(), {padding: [24, 24, 24, 24]})
            } else if (this.boundaries && this.boundaries.getSource().getFeatures().length > 0) {
                this.getView().fit(this.boundaries.getSource().getExtent(), {padding: [24, 24, 24, 24]})
            }
        } catch (err) {
        }
    }

    /**
     * Setup tooltips
     * @param property Feature property to use as a tooltip
     * @param features Type of features to use with tooltips
     */
    setupTooltips(property, features = null) {
        this.container.css({position: 'relative'});

        this.map.on('pointermove', (event) => {

            let f = null;

            let featuresAtPixel = this.map.getFeaturesAtPixel(event.pixel)
            if(featuresAtPixel.length > 0) {
                f = featuresAtPixel[0];
            }

            let tooltip = $(".map-tooltip");

            if(f === null || (features !== null && !features.includes(f.get('type')))) {
                if (this.tooltipVisible) {
                    tooltip.hide();
                    this.tooltipVisible = false;
                }
                return;
            }

            if(features !== null && !features.includes(f.get('type'))) {
                return;
            }

            let data = f.get(property);
            if(tooltip.length === 0) {
                tooltip = $('<div class="map-tooltip"></div>')
                this.container.append(tooltip)
            }


            tooltip.html(data);
            tooltip.css({
                'left': event.pixel[0] + 16,
                'top': event.pixel[1] + 16
            })

            if (!this.tooltipVisible) {
                tooltip.show();
                this.tooltipVisible = true;
            }
        })
    }

    addRuler() {
        this.ruler = new Ruler(this);
        this.rulerControl = new RulerControl({epMap: this});

        this.map.addControl(this.rulerControl);
    }
}
